import {getDeviceInfo} from '@xc/hiya-jsbridge'
import {hAppEnum, useEnv} from 'hiya-common/src/reducers/env'
import {useState} from 'react'
import {isNode} from '..'

export const isSaadaFn = (
  env?: {
    host?: string
    deviceinfo?: {
      h_app?: string
    }
  } | string | null
) => {
  if (typeof env === 'string') {
    return env.toLowerCase() === hAppEnum.saada
  }
  if (env?.host?.includes('saada.com')) {
    return true
  }
  return env?.deviceinfo?.h_app?.toLowerCase() === hAppEnum.saada
}

export const useIsSaada = () => {
  const env = useEnv()

  return isSaadaFn(env)
}

export const useIsHiya = () => {
  const {deviceinfo} = useEnv()

  const isHiya = [hAppEnum.lite, hAppEnum.game, hAppEnum.pro].includes(
    deviceinfo?.h_app?.toLowerCase() as any
  )
  return isHiya
}

// 因为有些页面无法通过openScheme内的need_user_info获取到h_app，所以需要通过jsbridge获取
export const useIsSaadaByJsBridge = () => {
  const [isSaada, setIsSaada] = useState(false)
  getDeviceInfo().then((res) => {
    setIsSaada(isSaadaFn(res.h_app))
  })

  return isSaada
}
